import type { AppConfig } from './appConfig.ts';

function parseScopes(value: unknown): string[] {
    if (Array.isArray(value)) {
        return value.filter((v): v is string => typeof v === 'string' && v.trim().length > 0);
    }
    if (typeof value === 'string' && value.trim()) {
        return value
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
    }
    return [];
}

export function loadAppConfig(configElement: HTMLScriptElement | null): AppConfig {
    const defaults: AppConfig = {
        supportEmail: '',
        supportPhone: '',
        clientId: '',
        appAuthority: 'https://login.microsoftonline.com/organizations',
        apiBaseUrl: '',
        apiScopes: [],
        mapTileUrl: '',
        satTileUrl: '',
        googleMapsApiKey: '',
    };

    if (!configElement?.textContent) {
        return defaults;
    }

    let parsed: unknown;
    try {
        parsed = JSON.parse(configElement.textContent);
    } catch {
        return defaults;
    }

    if (typeof parsed !== 'object' || parsed === null) {
        return defaults;
    }

    const raw = parsed as Record<string, unknown>;
    return {
        supportEmail: typeof raw.supportEmail === 'string' ? raw.supportEmail : defaults.supportEmail,
        supportPhone: typeof raw.supportPhone === 'string' ? raw.supportPhone : defaults.supportPhone,
        clientId: typeof raw.clientId === 'string' ? raw.clientId : defaults.clientId,
        appAuthority:
            typeof raw.appAuthority === 'string' && raw.appAuthority.trim() ? raw.appAuthority : defaults.appAuthority,
        apiBaseUrl: typeof raw.apiBaseUrl === 'string' ? raw.apiBaseUrl : defaults.apiBaseUrl,
        apiScopes: parseScopes(raw.apiScopes),
        mapTileUrl: typeof raw.mapTileUrl === 'string' ? raw.mapTileUrl : defaults.mapTileUrl,
        satTileUrl: typeof raw.satTileUrl === 'string' ? raw.satTileUrl : defaults.satTileUrl,
        googleMapsApiKey: typeof raw.googleMapsApiKey === 'string' ? raw.googleMapsApiKey : defaults.googleMapsApiKey,
    };
}
